import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiUser, FiInfo, FiHash } = FiIcons;
import { format } from 'date-fns';

export default function LeadTable({ leads, onSelectLead }) {
  const getStatusBadge = (sent) => (
    <div className={`w-2 h-2 rounded-full ${sent ? 'bg-emerald-400 shadow-[0_0_8px_rgba(52,211,153,0.5)]' : 'bg-slate-200'}`}></div>
  );

  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full text-left border-collapse min-w-[900px]">
        <thead>
          <tr className="bg-slate-50/50 border-b border-slate-100">
            <th className="py-5 px-8 text-[10px] font-black text-slate-400 uppercase tracking-widest">Received Date</th>
            <th className="py-5 px-6 text-[10px] font-black text-slate-400 uppercase tracking-widest">Visitor Identity</th>
            <th className="py-5 px-6 text-[10px] font-black text-slate-400 uppercase tracking-widest">Message Preview</th>
            <th className="py-5 px-6 text-[10px] font-black text-slate-400 uppercase tracking-widest">Source</th>
            <th className="py-5 px-6 text-[10px] font-black text-slate-400 uppercase tracking-widest">Notifs</th>
            <th className="py-5 px-8 text-right text-[10px] font-black text-slate-400 uppercase tracking-widest">Action</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-50">
          {leads.map((lead) => (
            <tr 
              key={lead.id} 
              className="group hover:bg-slate-50/80 transition-all cursor-pointer"
              onClick={() => onSelectLead(lead)}
            >
              <td className="py-5 px-8">
                <div className="flex flex-col">
                  <span className="text-xs font-black text-slate-900">
                    {lead.created_at ? format(new Date(lead.created_at), 'dd MMM yyyy') : 'N/A'}
                  </span>
                  <span className="text-[10px] font-bold text-slate-400 uppercase mt-0.5">
                    {lead.created_at ? format(new Date(lead.created_at), 'h:mm a') : ''}
                  </span>
                </div>
              </td>
              <td className="py-5 px-6">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-xl bg-brand-blue/5 border border-brand-blue/10 flex items-center justify-center text-brand-blue group-hover:bg-brand-blue group-hover:text-white transition-colors">
                    <SafeIcon icon={FiUser} className="text-sm" />
                  </div>
                  <div className="flex flex-col overflow-hidden max-w-[180px]">
                    <span className="text-xs font-black text-slate-900 truncate">{lead.name || 'Anonymous'}</span>
                    <span className="text-[10px] font-bold text-slate-400 truncate">{lead.email || 'No email provided'}</span>
                  </div>
                </div>
              </td>
              <td className="py-5 px-6">
                <p className="text-xs text-slate-500 max-w-[240px] truncate font-medium">
                  "{lead.message || 'No message content'}"
                </p>
              </td>
              <td className="py-5 px-6">
                <span className="px-2.5 py-1 bg-slate-100 text-slate-500 rounded-lg text-[9px] font-black uppercase tracking-wider">
                  {lead.utm_source || 'Direct'}
                </span>
              </td>
              <td className="py-5 px-6">
                <div className="flex gap-1.5" title="Email / SMS Sent">
                  {getStatusBadge(lead.business_email_sent)}
                  {getStatusBadge(lead.customer_ack_sent)}
                  {getStatusBadge(lead.sms_sent)}
                </div>
              </td>
              <td className="py-5 px-8 text-right">
                <button className="inline-flex items-center gap-2 px-4 py-2 bg-slate-100 group-hover:bg-navy-900 group-hover:text-white text-slate-600 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all">
                  <SafeIcon icon={FiInfo} />
                  <span>Inspect</span>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}